import { render, staticRenderFns } from "./CalculatorMainSection.vue?vue&type=template&id=6012d9ba&scoped=true"
import script from "./CalculatorMainSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalculatorMainSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CalculatorMainSection.vue?vue&type=style&index=0&id=6012d9ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6012d9ba",
  null
  
)

export default component.exports